import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { NotifyProvider } from "@/context/NotifyContext";
import HomeLanding from "@/pages/HomeLanding";
import PartnerLanding from "@/pages/PartnerLanding";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminLogin from "@/pages/AdminLogin";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import CityStyleLanding from "@/pages/CityStyleLanding";
import RegionLanding from "@/pages/RegionLanding";
import NotifyMeModal from "@/components/NotifyMeModal";
import CookieConsentBanner from "@/components/CookieConsentBanner";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <LanguageProvider>
      <NotifyProvider>
        <BrowserRouter>
          <div className="min-h-screen bg-bg">
            <Routes>
              <Route path="/" element={<HomeLanding />} />
              <Route path="/customer" element={<Navigate to="/" replace />} />
              <Route path="/partner" element={<PartnerLanding />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="/region/:region" element={<RegionLanding />} />
              <Route path="/:style/:city" element={<CityStyleLanding />} />
              <Route path="/:style/:city/:district" element={<CityStyleLanding />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <NotifyMeModal />
            <CookieConsentBanner />
            <Toaster position="top-center" />
          </div>
        </BrowserRouter>
      </NotifyProvider>
    </LanguageProvider>
  );
}

export default App;
